import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (param) => {
	if (['sitemap.xml', 'sitemap-core.xml'].includes(param)) {
		return true;
	}

	return /sitemap-category-([A-Za-z-]{1,25})-(\d{1,5})\.xml/.test(param);
};
